export const scrollTo = (elemId: string, fallback?: () => void) => {
  const elem = document.getElementById(elemId);

  if (elem) {
    elem.scrollIntoView({ behavior: "smooth" });
  } else if (fallback) {
    fallback();
  }
};
